import { PaymentMethod } from '../../models';

export type Step = 'guest-info' | 'payment' | 'confirm';

export type PaymentMode = 'combine' | 'detailed';

export interface GuestBaby {
  id: number;
  name: string;
  birthdate: string;
  gender: string;
}

export interface GuestInfo {
  name: string;
  phone: string;
  street: string;
  number: string;
  neighborhood: string;
  city: string;
  state: string;
  zipCode: string;
  complement: string;
  email: string;
  cpfCnpj: string;
  babies: GuestBaby[];
  lookupConfirmed: boolean;
}

export interface PaymentEntry {
  paymentMethod: PaymentMethod;
  amountPaid: number;
  installments?: 1 | 2;
}

export const ALL_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.Pix,
  PaymentMethod.CreditCard,
  PaymentMethod.DebitCard,
  PaymentMethod.Cash,
];
